export const ACTUALIZAR_LIST_OPD = "ACTUALIZAR_LIST_OPD";
export const MODIFICAR_OPD = "MODIFICAR_OPD";
export const AGREGAR_OPD = "AGREGAR_OPD";
export const ELIMINAR_OPD = "ELIMINAR_OPD";
